/**
 * Kundenportal Api
 * Kundenportal Api
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LogLevelDto { 
    /**
     * The name of the cron job to change
     */
    logLevel: LogLevelDto.LogLevelEnum;
    serviceName: LogLevelDto.ServiceNameEnum;
}
export namespace LogLevelDto {
    export type LogLevelEnum = 'log' | 'error' | 'warn' | 'debug' | 'verbose' | 'fatal';
    export const LogLevelEnum = {
        LOG: 'log' as LogLevelEnum,
        ERROR: 'error' as LogLevelEnum,
        WARN: 'warn' as LogLevelEnum,
        DEBUG: 'debug' as LogLevelEnum,
        VERBOSE: 'verbose' as LogLevelEnum,
        FATAL: 'fatal' as LogLevelEnum
    };
    export type ServiceNameEnum = 'authentificationService' | 'documentService' | 'partnerService' | 'policeService';
    export const ServiceNameEnum = {
        AUTHENTIFICATION_SERVICE: 'authentificationService' as ServiceNameEnum,
        DOCUMENT_SERVICE: 'documentService' as ServiceNameEnum,
        PARTNER_SERVICE: 'partnerService' as ServiceNameEnum,
        POLICE_SERVICE: 'policeService' as ServiceNameEnum
    };
}


